const AppConfig = {
  PUBLIC_API_BASE_URL: 'https://lms.coderslab.pl/public-api',
  API_BASE_URL: 'https://lms.coderslab.pl/lms-api',
  SENTRY_DSN: '',
  LANG: 'pl',
  HUB_URL: 'https://hub.coderslab.pl',
  SHOW_GRADEBOOK_TAB: 1,
  LOGIN_REDIRECT_URL: 'https://lms.coderslab.pl/auth/github_connect?redirect_url=',
  COURSE_ICON_BASE_URL: 'https://lms.coderslab.pl/',
  TENANT_USER_LANGUAGES: 'pl,en',
  FEATURE_MATERIAL_ISSUE: 1,
  FEATURE_LEARNING_RESULTS: 0,
  COURSES_CATALOG_URL: 'https://coderslab.pl/pl/kursy',
  CONTACT_URL: 'https://coderslab.pl/pl/kontakt',
  USER_ENGAGE_API_KEY: 'lDuvtk',
  USER_ENGAGE_SCRIPT_URL: 'https://coderslab.user.com/widget.js',
  GTM_API_KEY: 'GTM-PLV3KL9',
};

export default AppConfig;
